module.exports = __webpack_public_path__ + "static/img/fo.037e466d.svg";